module.exports = "mutation UpdateIssue($data:IssueInput!){updateIssue(data:$data){success}}"